<div class="generalPage mt-3rem ml-6 mr-1rem print-content print-all-content">
  <h1 class="top-heading content-blue">{{header}}</h1>
<br />
  <span id="Publiccomment" [innerHtml]="exposurecontent" (click)="openLinkById($event)" (contextmenu)="onRightClick($event)"></span>
</div>
